import ReactModal from 'react-modal';

import { modalConfig, ModalName } from './constants';

interface Props {
  modalName?: ModalName;
  unsetModal(): void;
}

const Modal = (props: Props): JSX.Element | null => {
  const { modalName, unsetModal } = props;
  if (!modalName) {
    return null;
  }

  const config = modalConfig[modalName];
  if (!config) return null;

  return (
    <ReactModal
      isOpen={!!modalName}
      shouldCloseOnOverlayClick
      onRequestClose={unsetModal}
      className={config.classes}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          zIndex: 1000,
        },
      }}
      closeTimeoutMS={400}
    >
      {config.modal()}
    </ReactModal>
  );
};

export default Modal;
